var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fb"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.6048 26.6667H13.8751V15.3319H11.5117V11.4263H13.8751V9.08156C13.8751 5.89558 15.2089 4 19.0007 4H22.1567V7.90701H20.1842C18.7081 7.90701 18.6105 8.45281 18.6105 9.4714L18.6041 11.4263H22.1784L21.7601 15.3319H18.6041L18.6048 26.6667Z",
    fill: "#0027F9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.a99117a710d3f354919d97813cdc42a3.svg";
export { ForwardRef as ReactComponent };